export default __webpack_public_path__ + "static/media/4 Advantages - Low Cost.98ac74a6.png";